import { HAIKU, SONNET } from '../constants';

export { HAIKU, SONNET };

export async function callClaude(sys, userMsg, maxTokens=2000, useSearch=false, returnText=false, model=SONNET, session=null) {
  const body = {
    model,
    max_tokens: maxTokens,
    temperature: returnText ? 0.3 : 0,
    system: [{ type:"text", text:sys, cache_control:{ type:"ephemeral" } }],
    messages: [{ role:"user", content:userMsg }],
  };
  if (useSearch) body.tools = [{ type:"web_search_20250305", name:"web_search" }];
  if (session) body.session = session;
  const res = await fetch("/api/claude", {
    method:"POST",
    headers:{"Content-Type":"application/json"},
    body: JSON.stringify(body),
  });
  if (!res.ok) { const e = await res.json().catch(()=>({})); throw new Error(e.error || `HTTP ${res.status}`); }
  const json = await res.json();
  if (!json.content || !Array.isArray(json.content)) throw new Error("Invalid response structure");
  const text = json.content.filter(b=>b.type==="text").map(b=>b.text||"").join("");
  if (!text) throw new Error("Empty response from Claude");
  if (returnText) return text.trim();
  // Strip markdown code fences if present
  const cleaned = text.replace(/```json\n?/g,"").replace(/```\n?/g,"").trim();
  const s = cleaned.indexOf("{"), e = cleaned.lastIndexOf("}");
  if (s === -1) throw new Error("No JSON in response");
  try { return JSON.parse(cleaned.slice(s, e+1)); }
  catch {
    try { return JSON.parse(cleaned.slice(s, e+1).replace(/,\s*}/g,"}").replace(/,\s*]/g,"]")); }
    catch(e2) {
      console.error("Raw Claude response:", cleaned.slice(0, 500));
      throw new Error("JSON parse failed: " + e2.message);
    }
  }
}
